import { transitionStatusMapping } from '../../utils/styleHookMapping.js';
export const itemMapping = {
  checked(value) {
    if (value) {
      return {
        'data-checked': ''
      };
    }
    return {
      'data-unchecked': ''
    };
  },
  ...transitionStatusMapping
};